import { deleteEkgRecordingFromStack, postConfirmEkgRecording, putReassignEkgRecording, getDataSource, getMe } from '../../store/appReducer'
import { ROUTES, DATASOURCES, TRIAGE, ECG_STACK_CONTROLS_ACTION_TYPE, CLEAR_STATE } from '../../constants'
import history from '../../containers/History'

// ------------------------------------
// Constants
// ------------------------------------
const PREFIX = 'PatientEkgRecording.'
export const UPDATE_SELECTED_PATIENT_ID = `${PREFIX}UPDATE_SELECTED_PATIENT_ID`
export const UPDATE_SELECTED_RECORDING_ID = `${PREFIX}UPDATE_SELECTED_RECORDING_ID`
export const UPDATE_SELECTED_REASSIGN_INBOX_ID = `${PREFIX}UPDATE_SELECTED_REASSIGN_INBOX_ID`

// ------------------------------------
// Actions
// ------------------------------------
export const updateSelectedPatientId = patientId => ({
  type: UPDATE_SELECTED_PATIENT_ID,
  payload: patientId,
})
export const updateSelectedRecordingId = recordingId => ({
  type: UPDATE_SELECTED_RECORDING_ID,
  payload: recordingId,
})
export const updateSelectedReassignInboxId = reassignInboxId => ({
  type: UPDATE_SELECTED_REASSIGN_INBOX_ID,
  payload: reassignInboxId,
})


export const clearSelections = () => (dispatch, getState) => {
  dispatch(updateSelectedPatientId(''))
  dispatch(updateSelectedRecordingId(''))
  dispatch(updateSelectedReassignInboxId(''))
}

export const setInitialPatientEkgRecordingData = match => (dispatch, getState) => {
  const {
    patientId,
    recordingId,
  } = match.params

  dispatch(updateSelectedPatientId(patientId))
  dispatch(updateSelectedRecordingId(recordingId))
}

export const confirmAndArchiveCallback = actionType => (dispatch, getState) => {
  const {
    selectedPatientId,
    selectedRecordingId,
  } = getState().patientEkgRecording

  const ekgsDataSource = getDataSource(getState(), DATASOURCES.EKGS)
  const recording = ekgsDataSource.data.byId[selectedRecordingId]

  const mostRecentInterpretation = recording.memberInterpretations[0]

  switch (actionType) {
  case ECG_STACK_CONTROLS_ACTION_TYPE.CANCEL:
    break
  case ECG_STACK_CONTROLS_ACTION_TYPE.OK:
    return new Promise((resolve, reject) => {
      dispatch(postConfirmEkgRecording(mostRecentInterpretation.id))
        .then(() => {
          history.push(`${ROUTES.PATIENTS_PATIENT_FILE}/${selectedPatientId}`)
          resolve()
        })
        .catch(err => {
          console.log('confirmAndArchiveCallback', err)
          reject(err)
        })
    })
  default:
    break
  }
}

export const reassignCallback = actionType => (dispatch, getState) => {
  const {
    selectedPatientId,
    selectedRecordingId,
    selectedReassignInboxId,
  } = getState().patientEkgRecording

  const meDataSource = getDataSource(getState(), DATASOURCES.ME)
  const meDataTeams = meDataSource.data.teams
  let memberID = selectedReassignInboxId

  if (selectedReassignInboxId === TRIAGE) {
    memberID = null
  }
  const assignmentData = {
    memberID,
    teamID: meDataTeams[0].id,
  }

  switch (actionType) {
  case ECG_STACK_CONTROLS_ACTION_TYPE.CANCEL:
    return dispatch(updateSelectedReassignInboxId(''))
  case ECG_STACK_CONTROLS_ACTION_TYPE.OK:
    return new Promise((resolve, reject) => {
      dispatch(putReassignEkgRecording(selectedRecordingId, assignmentData))
        .then(() => {
          history.push(`${ROUTES.PATIENTS_PATIENT_FILE}/${selectedPatientId}`)
          resolve()
        })
        .catch(err => {
          console.log('confirmAndArchiveCallback', err)
          reject(err)
        })
    })
  default:
    break
  }
}

const initialState = {
  selectedPatientId: '',
  selectedRecordingId: '',
  selectedReassignInboxId: '',
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_SELECTED_PATIENT_ID]: (state, action) => ({
    ...state, selectedPatientId: action.payload,
  }),
  [UPDATE_SELECTED_RECORDING_ID]: (state, action) => ({
    ...state, selectedRecordingId: action.payload,
  }),
  [UPDATE_SELECTED_REASSIGN_INBOX_ID]: (state, action) => ({
    ...state, selectedReassignInboxId: action.payload,
  }),
  [CLEAR_STATE]: (state, action) => ({ ...initialState }),
}

// ------------------------------------
// Reducer
// ------------------------------------
export default function patientEkgRecordingReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/legacy/pages/PatientEkgRecording/module.js